var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAaneelWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 37,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 140 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 15.3726,
    y1: 1.5883,
    x2: 28.0332,
    y2: 21.925,
    gradientTransform: "translate(0 38) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#fff",
    stopOpacity: 0.9631
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2537,
    stopColor: "#fff",
    stopOpacity: 0.8632
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4473,
    stopColor: "#fff",
    stopOpacity: 0.7006
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#fff",
    stopOpacity: 0.475
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9208,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 32.4506,
    y1: 15.911,
    x2: 39.2852,
    y2: -0.8316,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3.6437,
    y1: 1.4259,
    x2: 15.894,
    y2: 20.9565,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 41.2877,
    y1: 4.3162,
    x2: 53.3755,
    y2: 24.0694,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 5416.4042,
    cy: 385.0448,
    fx: 5416.4042,
    fy: 385.0448,
    r: 2.9944,
    gradientTransform: "translate(469.1288 6087.664) rotate(-89.8502) scale(1.1213 -1.1213)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3994,
    stopColor: "#e6e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4508,
    stopColor: "#e8e9e9",
    stopOpacity: 0.9405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5461,
    stopColor: "#edeeee",
    stopOpacity: 0.7833
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#f6f7f7",
    stopOpacity: 0.5312
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fefefe",
    stopOpacity: 0.3157
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8554,
    stopColor: "#fcfcfc",
    stopOpacity: 0.3641
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#f9fafa",
    stopOpacity: 0.4455
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9212,
    stopColor: "#f5f6f6",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9527,
    stopColor: "#f0f1f1",
    stopOpacity: 0.7077
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    stopColor: "#eaeaea",
    stopOpacity: 0.8861
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e7e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 28.5328,
    y1: -1.71,
    x2: 18.7053,
    y2: 20.4018,
    gradientTransform: "translate(0 38) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0792,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#fff",
    stopOpacity: 0.475
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5527,
    stopColor: "#fff",
    stopOpacity: 0.7006
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7463,
    stopColor: "#fff",
    stopOpacity: 0.8632
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#fff",
    stopOpacity: 0.9631
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    stopColor: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M65.6135,20.6994c2.0781,0,3.8478.59,5.3093,1.7698,1.4614,1.1798,2.192,2.601,2.192,4.2637v6.3952c0,.2413-.1273.4456-.3821.6134-.2547.1675-.5631.2514-.9251.2514s-.6737-.0839-.9352-.2514c-.2614-.1677-.3922-.372-.3922-.6134v-3.2379h-7.1394c-.3619,0-.6737-.0871-.9351-.2614-.2615-.1743-.3922-.3821-.3922-.6234s.1307-.4491.3922-.6237c.2614-.1743.5732-.2614.9351-.2614h7.1394v-1.3875c0-1.18-.4759-2.1854-1.4278-3.0167-.952-.8313-2.0983-1.2469-3.439-1.2469s-2.4871.4156-3.4391,1.2469c-.9519.8313-1.4278,1.8368-1.4278,3.0167v6.4153c0,.2413-.1274.4491-.3822.6234-.2547.1745-.5631.2616-.9251.2616-.3754,0-.6905-.0871-.9452-.2616-.2547-.1743-.3821-.3821-.3821-.6234v-6.4153c0-1.6627.7341-3.0838,2.2022-4.2637,1.4681-1.1798,3.2346-1.7698,5.2993-1.7698h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6825,28.8847c0-1.4616.6468-2.7084,1.9407-3.7407,1.2939-1.0325,2.8524-1.5486,4.6759-1.5486s3.382.5161,4.6758,1.5486c1.2939,1.0322,1.9407,2.279,1.9407,3.7407v4.2434c0,.2413-.1307.4456-.3921.6134-.2615.1675-.5732.2514-.9352.2514s-.6703-.0839-.9251-.2514c-.2547-.1677-.3822-.372-.3822-.6134v-4.2434c0-.9789-.3888-1.8134-1.1664-2.5039s-1.7161-1.0357-2.8154-1.0357-2.0379.3452-2.8156,1.0357c-.7776.6905-1.1664,1.525-1.1664,2.5039,0,.9651.3888,1.7931,1.1664,2.4836s1.7161,1.0357,2.8156,1.0357c.4558,0,.9049-.0671,1.3475-.201.1876-.0671.3821-.1006.5832-.1006.2949,0,.5865.0771.8748.2313s.4324.372.4324.6537c0,.362-.2414.6234-.7239.7841-.8045.2681-1.6425.4023-2.5139.4023-1.8235,0-3.382-.5195-4.6759-1.5585-1.2939-1.0393-1.9407-2.2828-1.9407-3.7306h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6847,26.6925c0-3.8613,1.448-5.792,4.344-5.792,1.4614,0,2.7485.8446,3.8613,2.5339.7239,1.113,1.3005,2.4401,1.7295,3.9821.3352,1.22.7944,2.3461,1.3776,3.3786.5832,1.0322,1.0759,1.5888,1.4781,1.6692.5766,0,1.0291-.3485,1.3576-1.0458.3285-.6973.4927-1.6491.4927-2.8559v-6.8176c0-.2413.1307-.4491.3922-.6234.2614-.1743.5731-.2615.9351-.2615s.6703.0873.9251.2615c.2547.1743.3822.3821.3822.6234v6.8176c0,3.7677-1.4949,5.6514-4.4849,5.6514-1.4614,0-2.7217-.838-3.7808-2.5139-.6703-1.0458-1.2268-2.3664-1.6692-3.962-.3352-1.22-.8146-2.3496-1.438-3.3888-.6235-1.039-1.143-1.5988-1.5586-1.6792-.5229,0-.9385.3653-1.2469,1.096-.3083.7308-.4625,1.7062-.4625,2.9262v6.4356c0,.2413-.1273.4456-.3821.6134-.2547.1675-.5632.2514-.9252.2514-.3754,0-.6905-.0839-.9451-.2514-.2547-.1677-.3822-.372-.3822-.6134v-6.4356h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.6283,28.8847c0-1.4616.6468-2.7084,1.9407-3.7407,1.2939-1.0325,2.8524-1.5486,4.6759-1.5486,1.3943,0,2.6613.3183,3.801.9553,1.1395.6369,1.9441,1.4714,2.4132,2.5039.0805.1878.1207.3753.1207.5631,0,.5766-.3017.9118-.9049,1.0055l-7.0791,1.1664c-.1073.0135-.2146.0203-.3218.0203-.3083,0-.5898-.0671-.8446-.2013-.3218-.1743-.4827-.4021-.4827-.6837,0-.4557.3352-.7373,1.0056-.8445l5.7115-.9253c-.7776-1.2065-1.9173-1.8099-3.4188-1.8099-1.0995,0-2.0379.3452-2.8156,1.0357s-1.1664,1.525-1.1664,2.5039c0,.9651.3888,1.7931,1.1664,2.4836s1.7161,1.0357,2.8156,1.0357c1.4077,0,2.5139-.5295,3.3183-1.5888.2413-.3217.6302-.4827,1.1664-.4827.2146,0,.4156.0268.6034.0806.4826.1607.7239.4221.7239.7841,0,.1475-.047.2817-.1407.4023-.6034.8044-1.4045,1.4346-2.4034,1.8905s-2.0881.6837-3.268.6837c-1.8235,0-3.382-.5195-4.6759-1.5585-1.2939-1.0393-1.9407-2.2828-1.9407-3.7306h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.7453,28.8847c0-1.4616.6468-2.7084,1.9407-3.7407,1.2939-1.0325,2.8524-1.5486,4.6759-1.5486,1.3943,0,2.6613.3183,3.801.9553,1.1395.6369,1.9441,1.4714,2.4132,2.5039.0805.1878.1207.3753.1207.5631,0,.5766-.3017.9118-.9049,1.0055l-7.0791,1.1664c-.1073.0135-.2146.0203-.3218.0203-.3083,0-.5898-.0671-.8446-.2013-.3218-.1743-.4827-.4021-.4827-.6837,0-.4557.3352-.7373,1.0056-.8445l5.7115-.9253c-.7776-1.2065-1.9173-1.8099-3.4188-1.8099-1.0995,0-2.0379.3452-2.8156,1.0357s-1.1664,1.525-1.1664,2.5039c0,.9651.3888,1.7931,1.1664,2.4836s1.7161,1.0357,2.8156,1.0357c1.4078,0,2.5139-.5295,3.3183-1.5888.2413-.3217.6302-.4827,1.1664-.4827.2146,0,.4156.0268.6034.0806.4826.1607.7239.4221.7239.7841,0,.1475-.047.2817-.1407.4023-.6034.8044-1.4045,1.4346-2.4034,1.8905s-2.0881.6837-3.268.6837c-1.8235,0-3.382-.5195-4.6759-1.5585-1.2939-1.0393-1.9407-2.2828-1.9407-3.7306h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.365,21.7451c0-.2413.1274-.4491.3822-.6234.2546-.1743.5697-.2615.9451-.2615.362,0,.6705.0873.9252.2615.2547.1743.3821.3821.3821.6234v11.3829c0,.2413-.1273.4456-.3821.6134-.2547.1675-.5632.2514-.9252.2514-.3754,0-.6905-.0839-.9451-.2514-.2547-.1677-.3822-.372-.3822-.6134v-11.3829h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3488,21.4174c-.579.6617-1.3317,1.7288-1.89,2.6262,0,0-.6204.9926-1.4847,2.3656l-2.4814-5.6287c.6452-1.0257,1.2366-1.9728,1.7287-2.7544.8933-.0869,1.493.1985,1.8735.4301.0662.0413.1323.0827.1944.1282.062.0413.1199.0869.182.1323.8602.6824,1.4144,1.6832,1.6584,2.2044,0,0,.1654.3639.2192.4963h0ZM19.9607,26.4092c-1.89,3.015-3.4492,5.4964-3.4533,5.5005-1.0546,1.6874-2.8495,2.8743-4.9174,3.1225.5501.6286,1.187,1.1373,1.9521,1.4847.7486.3433,1.6253.5294,2.498.5294,1.9686,0,3.8379-.9181,4.7933-2.4401.0041-.0041.6865-1.0918,1.6088-2.5683-.6948-1.5757-1.6212-3.6767-2.4814-5.6288h0Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3041,35.0264c-.3641.5158-.8344.9558-1.373,1.2896-.7434.4627-1.6157.732-2.5563.732-1.8319,0-3.5842-1.0089-4.2479-2.5222-.0038-.0114-2.8484-6.4667-4.6196-10.4794-.4096-.9254-.9406-2.1353-1.1568-2.6284-.0569-.1327-.22-.4969-.22-.4969-.2465-.5196-.8003-1.5209-1.6612-2.2036-.0607-.0455-.1176-.091-.1783-.1327-.0645-.0455-.1289-.0873-.1972-.129-.3793-.2314-.9785-.5158-1.8736-.4286.0228-.0379.0493-.0759.0721-.1138.11-.1669.2238-.3148.3413-.4551.6182-.732,1.3009-1.0999,1.4488-1.1795.7244-.3945,1.5475-.6182,2.4236-.6182,1.0051,0,1.9457.2921,2.7346.8003.8609.55,1.5474,1.354,1.9495,2.3022l6.1215,13.8777c.531,1.2099,1.6802,2.067,2.9925,2.3856h0Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7619,21.4179c-.5803.6599-1.335,1.7295-1.8926,2.6246,0,0-6.6207,10.5545-6.626,10.5629-.952,1.5247-2.8218,2.4425-4.7903,2.4425-.8761,0-1.7523-.1896-2.4994-.531-.7661-.3489-1.4033-.8572-1.9533-1.4868,2.0671-.2465,3.8648-1.4337,4.9192-3.1215.0076-.0076,5.9584-9.4971,8.712-13.8815.8951-.0872,1.4944.1972,1.8736.4286.0683.0417.1327.0834.1972.129.0607.0417.1176.0872.1783.1327.8609.6827,1.4147,1.684,1.6612,2.2036,0,0,.1631.3641.22.4969h0Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8386,16.6352c-4.0393,6.4401-9.8422,15.6945-11.5338,18.3911-1.3123-.3186-2.4615-1.1757-2.9925-2.3856l-.6296-1.4299c2.0974-3.3414,6.5615-10.4529,9.7588-15.5541.5765,1.1113,1.7409,1.866,3.0797,1.866.8913,0,1.703-.3338,2.3174-.8875h0Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7917,11.4109c1.488.0023,2.6906,1.2074,2.6858,2.6906-.0031,1.479-1.2131,2.6766-2.7031,2.6708-1.488-.0027-2.6925-1.2046-2.6877-2.6875.005-1.4801,1.2131-2.6791,2.705-2.6739Z",
    style: {
      fill: "url(#radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7144,35.0281c-.3639.5128-.8354.9554-1.373,1.2862-.7403.4632-1.6129.732-2.5559.732-1.8321,0-3.5815-1.0091-4.2474-2.5187-.0041-.0041-.4508-1.0174-1.096-2.4897-.6948-1.5757-1.6212-3.6767-2.4814-5.6288-.3681-.8313-.7238-1.6377-1.0422-2.3615-.4095-.9264-.9388-2.1382-1.158-2.6303-.0538-.1323-.2192-.4963-.2192-.4963-.244-.5211-.7982-1.5219-1.6626-2.2044-.0579-.0455-.1158-.091-.1778-.1323-.062-.0455-.1282-.0869-.1944-.1282-.3805-.2316-.9802-.517-1.8735-.4301.0207-.0372.0496-.0744.0703-.1117.1117-.1696.2233-.3143.3433-.4549.6162-.732,1.2986-1.1001,1.4475-1.1828.7238-.3929,1.5468-.6162,2.4235-.6162,1.005,0,1.9438.2936,2.7337.8023.8602.5459,1.5468,1.3524,1.9521,2.2995l.8892,2.0182,2.4814,5.6287,2.7502,6.2326c.5294,1.2076,1.6791,2.0679,2.9901,2.3863h0Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.4016,3.9179c-.1875.353-.4883.6406-.9014.8618-.4131.2217-.9424.3325-1.5889.3325h-1.4189v3.1772h-1.2852V.4594h2.7041c.6006,0,1.1104.103,1.5264.3096.417.2065.7285.4863.9355.8394.2061.353.3096.7476.3096,1.1831,0,.3979-.0938.7734-.2812,1.1265ZM79.0041,3.7324c.2402-.2217.3604-.5352.3604-.9409,0-.8564-.4844-1.2847-1.4531-1.2847h-1.4189v2.5576h1.4189c.4883,0,.8525-.1108,1.0928-.332Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0149,7.9911c-.4736-.2666-.8447-.6426-1.1152-1.127s-.4062-1.0459-.4062-1.6841c0-.6313.1396-1.1904.417-1.6787.2783-.4883.6572-.8638,1.1387-1.127.4805-.2627,1.0176-.394,1.6104-.394.5938,0,1.1309.1313,1.6113.394.4805.2632.8604.6387,1.1377,1.127.2783.4883.417,1.0474.417,1.6787,0,.6309-.1426,1.1904-.4277,1.6787-.2861.4883-.6748.8657-1.166,1.1323-.4922.2666-1.0352.3999-1.6279.3999-.5859,0-1.1162-.1333-1.5889-.3999ZM85.5325,7.039c.2891-.1577.5244-.3945.7051-.71.1797-.3154.2695-.6982.2695-1.1489s-.0859-.832-.2588-1.1436c-.1729-.312-.4023-.5469-.6875-.7046s-.5928-.2363-.9238-.2363c-.3301,0-.6367.0786-.918.2363s-.5049.3926-.6699.7046c-.166.3115-.248.6929-.248,1.1436,0,.6685.1709,1.1846.5127,1.5488.3418.3647.7715.5464,1.29.5464.3301,0,.6396-.0786.9287-.2363Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4368,2.0815l-1.9268,6.208h-1.3525l-1.25-4.5854-1.251,4.5854h-1.3516l-1.9385-6.208h1.3076l1.2949,4.9912,1.3184-4.9912h1.3408l1.2617,4.9688,1.2852-4.9688h1.2617Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0383,5.6645h-4.7432c.0381.4956.2217.894.5527,1.1943.3301.3003.7354.4507,1.2168.4507.6904,0,1.1787-.2891,1.4639-.8677h1.3857c-.1875.5708-.5273,1.0386-1.0195,1.4028s-1.1025.5464-1.8301.5464c-.5938,0-1.125-.1333-1.5947-.3999s-.8379-.6426-1.1045-1.127-.3994-1.0459-.3994-1.6841c0-.6387.1299-1.2002.3887-1.6846s.623-.8579,1.0928-1.1211c.4697-.2627,1.0088-.394,1.6172-.394.585,0,1.1074.1274,1.5654.3828s.8154.6143,1.0703,1.0762c.2559.4619.3828.9932.3828,1.5942,0,.2329-.0146.4429-.0449.6309ZM102.7434,4.6279c-.0078-.4731-.1768-.8525-.5078-1.1382-.3301-.2852-.7393-.4277-1.2275-.4277-.4434,0-.8223.1406-1.1377.4224s-.5039.6631-.5635,1.1436h3.4365Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3791,2.2451c.3115-.1763.6816-.2646,1.1094-.2646v1.3291h-.3262c-.5039,0-.8848.1279-1.1436.3833-.2598.2554-.3887.6982-.3887,1.3296v3.2671h-1.2852V2.0815h1.2852v.9014c.1875-.3154.4365-.5615.749-.7378Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.3157,5.6645h-4.7432c.0381.4956.2217.894.5527,1.1943.3301.3003.7354.4507,1.2168.4507.6904,0,1.1787-.2891,1.4639-.8677h1.3857c-.1875.5708-.5273,1.0386-1.0195,1.4028s-1.1025.5464-1.8301.5464c-.5938,0-1.125-.1333-1.5947-.3999s-.8379-.6426-1.1045-1.127-.3994-1.0459-.3994-1.6841c0-.6387.1299-1.2002.3887-1.6846s.623-.8579,1.0928-1.1211c.4697-.2627,1.0088-.394,1.6172-.394.585,0,1.1074.1274,1.5654.3828s.8154.6143,1.0703,1.0762c.2559.4619.3828.9932.3828,1.5942,0,.2329-.0146.4429-.0449.6309ZM114.0207,4.6279c-.0078-.4731-.1768-.8525-.5078-1.1382-.3301-.2852-.7393-.4277-1.2275-.4277-.4434,0-.8223.1406-1.1377.4224s-.5039.6631-.5635,1.1436h3.4365Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5832,3.5014c.2588-.481.6123-.8545,1.0586-1.1211.4473-.2666.9453-.3999,1.4932-.3999.4053,0,.8057.0884,1.2002.2646s.708.4111.9404.7041V-.0479h1.2959v8.3374h-1.2959v-.9351c-.21.3003-.501.5483-.873.7437s-.7979.293-1.2783.293c-.541,0-1.0352-.1372-1.4824-.4116-.4463-.2739-.7998-.6567-1.0586-1.1489-.2588-.4917-.3887-1.0498-.3887-1.6733,0-.623.1299-1.1753.3887-1.6558ZM121.011,4.0644c-.1768-.3154-.4072-.5557-.6934-.7212-.2852-.165-.5928-.2476-.9238-.2476-.3301,0-.6377.0806-.9238.2422-.2852.1616-.5166.3979-.6924.71-.1768.3115-.2646.6816-.2646,1.1094,0,.4282.0879.8042.2646,1.127.1758.3228.4092.5688.6982.7378s.5957.2534.918.2534c.3311,0,.6387-.0825.9238-.2476.2861-.165.5166-.4077.6934-.7271.1768-.3188.2646-.6929.2646-1.1206,0-.4282-.0879-.8003-.2646-1.1157Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.4524,4.9321c.293.3682.4395.7852.4395,1.2505,0,.3984-.1035.7568-.3096,1.0762-.207.3193-.5059.5708-.8955.7549-.3906.1841-.8457.2759-1.3633.2759h-3.1328V.4594h2.9863c.5332,0,.9912.0898,1.374.27s.6719.4229.8672.7271.293.644.293,1.0195c0,.4507-.1201.8262-.3604,1.1265-.2402.3008-.5635.5225-.9688.665.4209.0747.7773.2964,1.0703.6646ZM128.4758,3.749h1.5879c.4209,0,.749-.0957.9863-.2871.2363-.1919.3545-.4678.3545-.8281,0-.353-.1182-.6289-.3545-.8281-.2373-.1992-.5654-.2988-.9863-.2988h-1.5879v2.2422ZM131.2356,6.9262c.248-.21.3721-.5029.3721-.8789,0-.3828-.1318-.687-.3945-.9126-.2627-.2251-.6123-.3379-1.0479-.3379h-1.6895v2.4448h1.7344c.4355,0,.7773-.105,1.0254-.3154Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.8772,2.0815l-3.8086,9.125h-1.3291l1.2617-3.0186-2.4453-6.1064h1.4316l1.7461,4.7319,1.8135-4.7319h1.3301Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaneelWhiteLogo);
export default __webpack_public_path__ + "static/media/aaneel-white-logo.c72790fc5d222f3d3e86ed51d79268f6.svg";
export { ForwardRef as ReactComponent };